import * as React from 'react';
import { EpiserverProperty } from 'sos-common/js/utils/episerver.property';
import { FormSectionBase, FormSectionBaseState } from '../Types/FormSectionBase';
import { setInnerHtml } from 'sos-common/js/utils/helpers';

export interface IInforutaProps {}
export interface IInforutaState extends FormSectionBaseState {}

export default class Inforuta extends FormSectionBase<IInforutaProps, IInforutaState> {
  constructor(props: IInforutaProps) {
    super(props);

    this.state = {
      errors: this.emptyErrorsMap,
    };
  }

  public render() {
    const { isInEditMode } = this.context;
    return (
      <EpiserverProperty propertyName="InformationBox" usingDangerouslySetInnerHTML={true} isInEditMode={isInEditMode}>
        <div
          className="importantinfo"
          dangerouslySetInnerHTML={setInnerHtml(this.findProperty('InformationBox'))}></div>
      </EpiserverProperty>
    );
  }
}
